export default __webpack_public_path__ + "85834efd60bd8a71c33120e19bc93341.png";